export const ENABLE_GO_LIVE_TEXT = {
    message: 'Meeting go-live date is',
    id: 'oe.meeting.enableGoLive',
    description: 'Label text for go-live toggle'
};

export const GO_LIVE_INFO_MESSAGE_TEXT = {
    id: 'oe.meeting.goLiveInfoMessage',
    description: 'Info popover message explaining go-live feature',
    message: 'If a go-live date is enabled, then the meeting will be unavailable and hidden in Passport until the go-live time, which must be at or before the meeting start time.'
};

export const GO_LIVE_DATE_TIME_REQUIRED_TEXT = {
    id: 'oe.meeting.goLiveDateTimeRequired',
    defaultMessage: 'Go-live date and time are mandatory if enabled',
    description: 'Validation error message when go-live date or time is missing'
};

export const GO_LIVE_TIME_TEXT = {
    id: 'oe.meeting.goLiveTime',
    defaultMessage: 'Time',
    description: 'Label text for go-live time picker'
};

export const GO_LIVE_AFTER_START_TIME_TEXT = {
    id: 'oe.meeting.goLiveAfterStartTime',
    defaultMessage: 'Go-live time cannot be after meeting start time',
    description: 'Validation error message when go-live time is after meeting start time'
};
